<template>
  <div class="aha-ribbon">
    <aha-icon
      class="aha-ribbon--icon"
      name="ribbon-star"
      viewBox="0 0 20 20"
      maintainColor
    ></aha-icon>
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scoped>
.aha-ribbon {
    --ribbonColor: #FFA826;

    position: relative;
    background: linear-gradient(266.1deg, #FFA826 15.75%, #FFBF1F 57.99%);
    width: 32px;
    height: 52px;
    clip-path: polygon(100% 0, 100% 100%, 50% 80%, 0 100%, 0 0);
    box-shadow: 0px 8px 14px 0px rgba(10, 10, 10, 0.1);

    & .aha-ribbon--icon {
        transform: translate(6px, 12px);
    }
}

</style>
